// extracted by mini-css-extract-plugin
export default {"cls1":"VeloFlagLabel-FlagIcon_cls1__GvnJB","cls2":"VeloFlagLabel-FlagIcon_cls2__rCTz2 VeloFlagLabel-FlagIcon_cls1__GvnJB"};